/**
 * Las cargas con consentimiento del WhatsApp oficial dentro de Público (`/activa/publico/cargas/…`): el asistente
 * (`nueva`) y el detalle (`:id`). Vivían en «Base de datos», que salió del menú el 17/10/2026 (pedido de Alan: «todo lo
 * toma desde Público»); la lista es la pestaña «Con consentimiento» de Público.
 *
 * `HaciaLasCargas`: las direcciones viejas (`/activa/oficial/base/cargas/nueva?carga=…`, `/activa/oficial/base/cargas/:id`)
 * llevan acá con su id y su `?carga=`, así un link guardado o un borrador a medio hacer se sigue abriendo.
 */

import { Navigate, Outlet, useLocation, useParams } from "react-router-dom";
import { R_CARGAS } from "../../wa-oficial/components/base/comun";

export function HaciaLasCargas() {
  const { id } = useParams();
  const { search } = useLocation();
  return <Navigate to={`${R_CARGAS}/${id ? encodeURIComponent(id) : "nueva"}${search}`} replace />;
}

export default function CargasLayout() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 space-y-5">
      <div>
        <p className="text-xs font-semibold uppercase tracking-wider text-slate-400">Público</p>
        <h1 className="text-2xl font-bold text-slate-900">Contactos con consentimiento</h1>
        <p className="text-sm text-slate-500 mt-0.5">Para WhatsApp oficial: cada persona queda con su sí, de dónde lo dio y cuándo.</p>
      </div>
      <Outlet />
    </div>
  );
}
